import { useEffect, useState } from "react";
import Entrada from "../page/Entrada";
import Header from "../components/body/Header";
import Footer from "../components/body/Footer";
import apiAntesala from "../../config/ConfigPublic";
import { useLocation, useParams } from "react-router-dom";
import { TotalEntradaUtils } from "../utils/TotalEntradaUtils";
import { useDispatch, useSelector } from "react-redux";
import { meState } from "../../web/models/users/Index";
import RestPrivateAntesala from "../../helpers/RestPrivateApi";
import Alerts from "../../web/components/Alerts/Alerts";
import Completado from "../page/Completado";

const EntradaController = () => {
  const dispatch = useDispatch();
  const _me = useSelector(meState);
  const me = _me.me;

  const { pathname } = useLocation();
  const { slug } = useParams();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(null);
  const [membresia, setMembresia] = useState(null);
  const [reporte, setReporte] = useState(null);
  const [comission, setComission] = useState(15);
  const [stock, setStock] = useState(true)

  const [evento, setEvento] = useState(null);
  const [form, setForm] = useState({
    fecha: null,
    stock: 0,
  });

  const label = (step) => {
    switch (step) {
      case 0:
        {
          return (
            <label
              className={`btn btn-custom-naranja text-white fw-normal py-4 d-flex justify-content-center align-items-center fs-6 ${evento.entradas.filter((e) => e.quantity).length > 0
                ? ""
                : "disabled"
                }`}
              style={{ width: "160px", borderRadius: "10px" }}
            >
              Siguiente
              <i class="bi bi-chevron-right fs-6"></i>
              <button
                className="d-none"
                onClick={(e) => {
                  let int = step + 1;
                  console.log(int);

                  switch (int) {
                    case 1:
                      {
                        document.getElementById("nav-pagar-tab").click();
                        document
                          .getElementById("nav-pagar-tab-ofcanva")
                          .click();

                        /*
                        let entradas = {
                          select: form,
                          evento: evento,
                        };

                        localStorage.setItem(
                          "entradas",
                          JSON.stringify(entradas)
                        );
                        return (window.location.href = "/pagar");
                        */
                      }
                      break;
                    default:
                      break;
                  }
                  setStep(int);
                }}
              ></button>
            </label>
          );
        }
        break;
      case 1:
        {
          return (
            <div className="d-flex">
              <label
                className={`btn btn-custom-naranja d-flex justify-content-center align-items-center fs-6 text-white fw-normal py-2  me-2 ${loading ? "disabled" : ""
                  }`}
                style={{ width: "160px", borderRadius: "10px" }}
              >
                Pagar
                <i class="bi bi-chevron-right fs-6"></i>
                <button
                  className="d-none"
                  name={`${TotalEntradaUtils(evento.entradas, comission).total > 0
                    ? "pagar"
                    : "gratis"
                    }`}
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
          );
        }
        break;
      default:
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "gratis":
        {
          const formdata = new FormData();
          formdata.append("nombre", me.nombre);
          formdata.append("email", me.email);
          formdata.append("telefono", me.telefono);
          formdata.append("id_evento", evento.id);
          formdata.append("fecha", form.fecha);
          formdata.append("hora", form.hora);
          evento.entradas.map((entrada, index) => {
            if (entrada.quantity ?? null) {
              formdata.append("entradas[" + index + "][id]", entrada.id);
              formdata.append(
                "entradas[" + index + "][quantity]",
                entrada.quantity
              );
            }
          });

          const result = await RestPrivateAntesala({
            url: "/checkout/free",
            formData: formdata,
            setLoading: setLoading,
            method: "POST",
          });

          if (result.status == 200) {
            setReporte({
              reporte: result.data.data,
            });
            return Alerts({
              msg: "Alert",
              title: "Entradas adquiridas",
              code: "401",
              type: "success",
            });
          }
        }
        break;
      case "pagar":
        {
          localStorage.removeItem("entradas");
          let entradas = {
            select: form,
            evento: evento,
            info: TotalEntradaUtils(evento.entradas, comission),
          };
          localStorage.setItem("entradas", JSON.stringify(entradas));
          return (window.location.href = "/checkout/"+evento?.id);
        }
        break;
      case "abonar-con-membresia":
        {
          setMembresia(value);

          const formdata = new FormData();
          formdata.append("nombre", me.nombre);
          formdata.append("email", me.email);
          formdata.append("telefono", me.telefono);
          formdata.append("id_evento", evento.id);
          formdata.append("membresia", value.code);
          formdata.append("fecha", form.fecha);
          formdata.append("hora", form.hora);
          evento.entradas.map((entrada, index) => {
            if (entrada.quantity ?? null) {
              formdata.append("entradas[" + index + "][id]", entrada.id);
              formdata.append(
                "entradas[" + index + "][quantity]",
                entrada.quantity
              );
            }
          });

          const response = await RestPrivateAntesala({
            url: "/checkout/paymembership",
            formData: formdata,
            setLoading: setLoading,
            method: "POST",
          });

          if (response.status == 201 || response.status == 200) {
            document.getElementById("modal-comprar-entradas").click();
            return Alerts({
              msg: "Alert",
              title: response.data?.msg,
              code: "401",
              type: "success",
            });
          } else {
            if (typeof response.data.msg == "string") {
              Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "warning",
              });
            } else {
              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          }
        }
        break;
      case "add-date":
        {
          if (value.select == "Selecciona una fecha valida") {
            setStock(true);
            return setForm({
              ...form,
              fecha: null,
              stock: 0,
              hora: null,
            });
          }

          let stock = value.stock;
          let fecha = `${value.select} HORA: ${value.hora}`;

          evento.reportes.map((re) => {
            if (re.fecha == fecha) {
              let cantidad = re.cantidad;
              if (re.multiplicador && re.multiplicador !== 0) {
                cantidad = cantidad * re.multiplicador;
              }
              stock -= cantidad;
            }
          })

          if (stock <= 0) {
            return setStock(false)
          }

          setStock(true);
          setForm({
            ...form,
            fecha: value.select,
            stock: value.stock,
            hora: value.hora,
          });
        }
        break;
      case "remove-date":
        {
          setForm({
            ...form,
            fecha: null,
            stock: 0,
          });
        }
        break;
      case "remove": {
        //Copiamos los valores de entradas
        let set = [...evento.entradas];
        const currentEntry = set[value.index];
        const quantity = (currentEntry?.quantity || 0) - 1;
        const multiplicador = (currentEntry?.multiplicador && currentEntry?.multiplicador !== 0) ? currentEntry?.multiplicador : 1;

        //Inicializamos variables de stock y cantidad
        let stock = 0;
        let totalQuantity = 0;

        //Si el stock es individual se resta directamente al stock de la entrada
        if (set[value.index]["stock"] > 0 && set[value.index]["stock"]) {
          stock = set[value.index]["stock"];
          evento.reportes.map((reporte) => {
            if (set[value.index]["id"] == reporte.entradas_id && reporte.fecha == form.fecha + " HORA: " + form.hora) {
              let cantidad = reporte.cantidad;
              if (reporte.multiplicador && reporte.multiplicador !== 0) {
                cantidad = cantidad * reporte.multiplicador;
              }
              stock = stock - cantidad;
            }
          });
          //Si el stock es general se resta al del dia total
        } else {
          //Se optiene el total de las demas entradas
          set.map((ent) => {
            if (currentEntry.id !== ent['id']) {
              let entQuantity = ent["quantity"] ?? 0;
              if (ent.multiplicador && ent.multiplicador !== 0) {
                entQuantity = entQuantity * ent.multiplicador;
              }
              totalQuantity = entQuantity + totalQuantity;
            }
          })
          //setea stock actual - la cantidad de las demas entradas
          stock = form.stock - totalQuantity;
          //Se obtiene la cantidad de las entradas reportadas y se resta al stock
          evento.reportes.map((reporte) => {
            if (
              reporte.fecha == form.fecha + " HORA: " + form.hora
            ) {
              let cantidad = reporte.cantidad;
              if (reporte.multiplicador && reporte.multiplicador !== 0) {
                cantidad = cantidad * reporte.multiplicador;
              }
              stock = stock - cantidad;
            }
          });
        }

        if (stock == 0 || stock - (quantity * multiplicador) <= 0 || quantity < 0) {
          return ""
        }

        //Actualiza
        set[value.index]["quantity"] = quantity;
        set[value.index]["pricexquantity"] = quantity * value.precio;
        set[value.index]["serv"] =
          (set[value.index]["pricexquantity"] / 100) * comission;

        if (set[value.index]["stock"] > 0 && set[value.index]["stock"]) {
          set[value.index]["remain"] = stock - (quantity * multiplicador);
        } else {
          set.forEach(ent => {
            ent["remain"] = stock - (quantity * multiplicador);
          })
        }

        return setEvento({
          ...evento,
          entradas: set,
        });
      } break;
      case "add": {
        //Copiamos los valores de entradas
        let set = [...evento.entradas];
        const currentEntry = set[value.index];
        const quantity = (currentEntry?.quantity || 0) + 1;
        const multiplicador = (currentEntry?.multiplicador && currentEntry?.multiplicador !== 0) ? currentEntry?.multiplicador : 1;

        //Inicializamos variables de stock y cantidad
        let stock = 0;
        let totalQuantity = 0;

        //Si el stock es individual se resta directamente al stock de la entrada
        if (set[value.index]["stock"] > 0 && set[value.index]["stock"]) {
          stock = set[value.index]["stock"];
          evento.reportes.map((reporte) => {
            if (set[value.index]["id"] == reporte.entradas_id && reporte.fecha == form.fecha + " HORA: " + form.hora) {
              let cantidad = reporte.cantidad;
              if (reporte.multiplicador && reporte.multiplicador !== 0) {
                cantidad = cantidad * reporte.multiplicador;
              }
              stock = stock - cantidad;
            }
          });
          //Si el stock es general se resta al del dia total
        } else {
          //Se optiene el total de las demas entradas
          set.map((ent) => {
            if (currentEntry.id !== ent['id']) {
              let entQuantity = ent["quantity"] ?? 0;
              if (ent.multiplicador && ent.multiplicador !== 0) {
                entQuantity = entQuantity * ent.multiplicador;
              }
              totalQuantity = entQuantity + totalQuantity;
            }
          })
          //setea stock actual - la cantidad de las demas entradas
          stock = form.stock - totalQuantity;
          //Se obtiene la cantidad de las entradas reportadas y se resta al stock
          evento.reportes.map((reporte) => {
            if (
              reporte.fecha == form.fecha + " HORA: " + form.hora
            ) {
              let cantidad = reporte.cantidad;
              if (reporte.multiplicador && reporte.multiplicador !== 0) {
                cantidad = cantidad * reporte.multiplicador;
              }
              stock = stock - cantidad;
            }
          });
        }

        if (stock == 0 || stock - (quantity * multiplicador) < 0) {
          return "";
        }

        //Actualiza
        set[value.index]["quantity"] = quantity;
        set[value.index]["pricexquantity"] = quantity * value.precio;
        set[value.index]["serv"] =
          (set[value.index]["pricexquantity"] / 100) * comission;

        if (set[value.index]["stock"] > 0 && set[value.index]["stock"]) {
          set[value.index]["remain"] = stock - (quantity * multiplicador);
        } else {
          set.forEach(ent => {
            ent["remain"] = stock - (quantity * multiplicador);
          })
        }

        return setEvento({
          ...evento,
          entradas: set,
        });
      } break;

    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "":
        {
        }
        break;
    }
  };

  const fetch = async (setData, params, url) => {
    const response = await apiAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!evento) {
      console.log(slug);

      fetch(setEvento, {}, `/eventos/${encodeURIComponent(slug)}`);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])


  if (reporte) {
    return <Completado reporte={reporte} />;
  }

  if (!evento) {
    return ""
  }



  return (
    <div className="container-fluid px-0 bg-light">
      <div className="w-100 shadow-sm mb-1 fixed-top bg-white">
        <Header discount={false} />
      </div>

      <div className="container-fluid min-vh-100">
        {evento ? (
          <Entrada
            setStep={setStep}
            step={step}
            entradas={evento?.entradas ?? []}
            onClick={onClick}
            comission={comission}
            form={form}
            evento={evento}
            label={label}
            me={me}
            membresia={membresia}
            loading={loading}
            stock={stock}
          />
        ) : null}
      </div>
      <div className="w-100 container-fluid px-0 mx-0">
        <Footer />
      </div>
    </div>
  );
};

export default EntradaController;
